module.exports = __webpack_public_path__ + "img/care-offer-1.3dc9d4fb.jpg";